(() => {
    const tablListItem = document.querySelectorAll('.tab-list-item');
    const tab1 = document.querySelectorAll('.tab-1');
    const tab2 = document.querySelectorAll('.tab-2');
    const tab3 = document.querySelectorAll('.tab-3');

    // Remove active class for tab
    function removeActiveTabList() {
        tablListItem.forEach(allTabs => {
            allTabs.classList.remove('active');
        });
    }

    // Show tab content based on tab
    function activeTab(tabName) {
        const tabs = document.querySelectorAll('.tab');
        tabs.forEach(tab => tab.classList.add('tab-hidden'));
        tabName.forEach(tab => tab.classList.remove('tab-hidden'));
    }

    // Change tabs on tab list click
    tablListItem.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();

            removeActiveTabList();

            e.currentTarget.classList.add('active');

            if (e.currentTarget.id === 'tab1') {
                activeTab(tab1);
                window.location.hash = 'trust';
            } else if (e.currentTarget.id === 'tab2') {
                activeTab(tab2);
                window.location.hash = 'safety';
            } else if (e.currentTarget.id === 'tab3') {
                activeTab(tab3);
                window.location.hash = 'security';
            }
        });
    });

    // Check window location hash to load selected tab on window load
    if (window.location.hash === '#trust') {
        removeActiveTabList();
        document.querySelector('#tab1').classList.add('active');
        activeTab(tab1);
    } else if (window.location.hash === '#safety') {
        removeActiveTabList();
        document.querySelector('#tab2').classList.add('active');
        activeTab(tab2);
    } else if (window.location.hash === '#security') {
        removeActiveTabList();
        document.querySelector('#tab3').classList.add('active');
        activeTab(tab3);
    }
})();
